<template>

<div :class="windowClass" @click="onClick"><slot /></div>

</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  class: String,
});
const windowClass = computed(() => ['frameWindow', props.class]);
const onClick = (event) => {
  event.stopPropagation();
};

</script>

<style lang="sass">

.frameWindow
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column

  position: relative
  padding: 40px

  background-color: white
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1)

  &
    border-radius: 6px

</style>
